module.exports = __webpack_public_path__ + "img/jb_t3411_52-1999.prt.28926379.jpg";